export function formatDate(strDate: string, language?: string): string {
  if (!strDate) return '';

  const date = new Date(strDate);
  const options = { day: 'numeric', month: 'long', year: 'numeric' };

  return date.toLocaleDateString(language, options);
}
